const initState = {
    query: "",
    groceryList: [],
    groceryListSelect: {},
    dish: [],
    dishItemSelect: {},
    dishNutrition: {},
    message: {},
    loading: false,
    payload_arrived: true,
    currentInventory: []
  }

  export default initState;


// WEBPACK FOOTER //
// ./src/Reducers/initState.js